module.exports = __webpack_public_path__ + "static/media/29.efc3985c.jpg";